import { render, staticRenderFns } from "./loginbox.vue?vue&type=template&id=6023a6ff&"
import script from "./loginbox.vue?vue&type=script&lang=js&"
export * from "./loginbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports